import { render, staticRenderFns } from "./service-items.vue?vue&type=template&id=b1c3e07a&scoped=true&"
import script from "./service-items.vue?vue&type=script&lang=ts&"
export * from "./service-items.vue?vue&type=script&lang=ts&"
import style0 from "./service-items.vue?vue&type=style&index=0&id=b1c3e07a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c3e07a",
  null
  
)

export default component.exports